import * as React from "react";
import type { SVGProps } from "react";
const SvgLogOutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="log-out_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M371.499 755.499a42.667 42.667 0 0 1-60.331 0L97.835 542.165a42.667 42.667 0 0 1 0-60.33L311.168 268.5a42.667 42.667 0 0 1 60.33 60.331L188.332 512 371.5 695.168a42.667 42.667 0 0 1 0 60.33z"
    />
    <path
      fill="currentColor"
      d="M682.667 512A42.667 42.667 0 0 1 640 554.667H128a42.667 42.667 0 1 1 0-85.334h512A42.667 42.667 0 0 1 682.667 512z"
    />
    <path
      fill="currentColor"
      d="M810.667 853.333a42.667 42.667 0 0 0 42.666-42.666V213.333a42.667 42.667 0 0 0-42.666-42.666H640a42.667 42.667 0 1 1 0-85.334h170.667a128 128 0 0 1 128 128v597.334a128 128 0 0 1-128 128H640a42.667 42.667 0 1 1 0-85.334h170.667z"
    />
  </svg>
);
export default SvgLogOutIcon;
